export default "__VITE_ASSET__6bf162b3__"